export default "__VITE_ASSET__CRkv$Mcy__"